import { LinkAlreadySentComponent } from './../family-registration/link-already-sent/link-already-sent.component';
import { NewFamilyRegistrationYearSelectionComponent } from './../family-registration/new-family-registration-year-selection/new-family-registration-year-selection.component';
import { EmailSentComponent } from './../family-registration/email-sent/email-sent.component';
import { DuplicateEmailAddressComponent } from './../family-registration/duplicate-email-address/duplicate-email-address.component';
import { LoginExistsComponent } from './../family-registration/login-exists/login-exists.component';
import { RegisterNewFamilyComponent } from './../family-registration/register-new-family/register-new-family.component';


import { RegisterNewFamilyMessageComponent } from './../family-registration/register-new-family-message/register-new-family-message.component';
import { SelectLanguageComponent } from './../family-registration/select-language/select-language.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { LoginFooterComponent } from './footer/login-footer.component';
import { LoginComponent } from './login.component';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from '../../app-routing.module';
import { SharedComponentsModule } from '../../shared-components/shared-components.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ForgotUsernameComponent } from './forgot-username/forgot-username.component';
import { StudentResetPasswordWarningComponent } from './forgot-password/student-reset-password-warning/student-reset-password-warning.component';
import { LoginAssistComponent } from './login-assist/login-assist.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ConfirmationModalComponent } from './forgot-username/confirmation-modal/confirmation-modal.component';
import { LoginOnly360Component } from './login-only360/login-only360.component';
import { InactivityTimeoutComponent } from './inactivity-timeout/inactivity-timeout.component';
import { UnsupportedBrowserWarningDialogComponent } from './unsupported-browser-warning-dialog/unsupported-browser-warning-dialog.component';
import { EmailNotSentComponent } from '../family-registration/email-not-sent/email-not-sent.component';
import { AccessMessageComponent } from './access-message/access-message.component';
import { CookieService } from 'ngx-cookie-service';
import { RegisterNewFamilyVerifyCodeComponent } from '../family-registration/register-new-family-verify-code/register-new-family-verify-code.component';
import { AuditLoginsComponent } from './audit-logins/audit-logins.component';

@NgModule({
    declarations: [
        ForgotPasswordComponent,
        ResetPasswordComponent,
        ForgotUsernameComponent,
        StudentResetPasswordWarningComponent,
        ConfirmationModalComponent,
        LoginComponent,
        LoginFooterComponent,
        ChangePasswordComponent,
        SelectLanguageComponent,
        RegisterNewFamilyMessageComponent,
        RegisterNewFamilyComponent,
        LinkAlreadySentComponent,
        LoginExistsComponent,
        DuplicateEmailAddressComponent,
        EmailSentComponent,
        NewFamilyRegistrationYearSelectionComponent,
        LoginAssistComponent,
        LoginOnly360Component,
        InactivityTimeoutComponent,
        UnsupportedBrowserWarningDialogComponent,
        EmailNotSentComponent,
        AccessMessageComponent,
        RegisterNewFamilyVerifyCodeComponent,
        AuditLoginsComponent
    ],
    imports: [
        SharedComponentsModule,
        AppRoutingModule
    ],
    providers: [
        CookieService
    ]
})
export class LoginModule {
}
